import * as React from 'react';
import { ImagePreview } from '.';
import { ImageUtils, ResizeImageResults } from './ImageUtils';

interface ImageUploadProps {
    maxWidth: number;
    maxHeight: number;
    imageBase64String?: string;
    label?: string;
    uploadHandler: (file: File) => void;
    imageChangedHandler?: () => void;
}

interface ImageUploadState {
    file?: File;
    imagePreviewUrl?: string;
    srcImageWidth?: number;
    srcImageHeight?: number;
}

export class ImageUpload extends React.Component<ImageUploadProps, ImageUploadState> {
    imageUtils = new ImageUtils();

    constructor(props: ImageUploadProps) {
        super(props);
        this.state = {
            imagePreviewUrl: this.props.imageBase64String
        };

        this.handleImageChange = this.handleImageChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    private handleSubmit(e: any) {
        e.preventDefault();

        if (this.state.file) {
            this.props.uploadHandler(this.state.file);
        }
    }

    private handleImageChange(e: any) {
        e.preventDefault();

        const file = e.target.files[0];

        const resizeSettings = { maxHeight: this.props.maxHeight, maxWidth: this.props.maxWidth, file: file };

        this.imageUtils.resizeImage(resizeSettings)
            .then(
                (result: ResizeImageResults) => {
                    this.setState({
                        file: result.newFile,
                        imagePreviewUrl: result.dataUrl
                    });

                    if (this.props.imageChangedHandler) {
                        this.props.imageChangedHandler();
                    }
                    
                }
            ).catch(() => { console.error('Error processing image.'); });
    }

    render() {
        const { imagePreviewUrl } = this.state;
        const { maxWidth, maxHeight, label } = this.props;

        let $imagePreview = null;
        if (imagePreviewUrl) {
            $imagePreview = <ImagePreview maxWidth={maxWidth} maxHeight={maxHeight} imageUrl={imagePreviewUrl} />;
        }

        let inputLabel = null;
        if (label) {
            inputLabel = <label>{label}</label>;
        }

        return (
            <div>
                <div className="form-group">
                    {inputLabel}
                    <div className="input-group">

                        <input type="file" className="form-control" onChange={this.handleImageChange} />
                        <span className="input-group-btn">
                            <button className="btn btn-primary" type="button" onClick={this.handleSubmit}>Upload</button>
                        </span>
                    </div>
                </div>

                {$imagePreview}
            </div>
        );
    }

}


// WEBPACK FOOTER //
// ./src/components/imageUpload/ImageUpload.tsx